import { createStore } from "./utils";
import { pendo } from "../tracking";

interface NavbarStore {
  isCollapsed: boolean;
  expandedSectionPaths: string[];
  toggleCollapsed: () => void;
  toggleExpandedSection: (sectionPath: string) => void;
}

export const { useStore: useNavbarStore, useShallowStore: useShallowNavbarStore } = createStore<NavbarStore>(
  (set) => ({
    isCollapsed: false,
    expandedSectionPaths: [],
    toggleCollapsed: () =>
      set((state) => {
        pendo.track(`app-sidebar-${state.isCollapsed ? "open" : "collapse"}`);
        return { isCollapsed: !state.isCollapsed };
      }),
    toggleExpandedSection: (sectionPath) =>
      set((state) => ({
        expandedSectionPaths: state.expandedSectionPaths.includes(sectionPath)
          ? state.expandedSectionPaths.filter((path) => path !== sectionPath)
          : [...state.expandedSectionPaths, sectionPath],
      })),
  }),
  {
    persist: "localStorage",
    name: "NAVBAR_STATE",
  }
);
